export default __webpack_public_path__ + "static/media/imatched_dark.06cc4ea7.png";